// PdfReportEditor.tsx

"use client";

import React, { useRef } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { highlightPlugin } from "@react-pdf-viewer/highlight";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";

import { IconButton, Typography, Box } from "@mui/material";
// import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";

// import { PDFDocument } from "pdf-lib";

interface Props {
  docUrl?: any;
  height?: string;
  className?: string;
  onClose?: () => void;
}

const PdfReportEditor: React.FC<Props> = ({
  docUrl,
  height = "100%",
  className = "",
  onClose,
}) => {
  const viewerRef = useRef<HTMLDivElement | null>(null);
  // const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const highlightPluginInstance = highlightPlugin();

  // const handleDownload = async () => {
  //   try {
  //     const existingPdfBytes = await fetch(docUrl.file).then((res) =>
  //       res.arrayBuffer()
  //     );
  //     const pdfDoc = await PDFDocument.load(existingPdfBytes);

  //     // Example modification: add footer text
  //     const pages = pdfDoc.getPages();
  //     pages.forEach((page) => {
  //       page.drawText("Edited with PdfReportEditor", {
  //         x: 50,
  //         y: 20,
  //         size: 8,
  //       });
  //     });

  //     const pdfBytes = await pdfDoc.save();
  //     const blob = new Blob([pdfBytes], { type: "application/pdf" });

  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `${docUrl.name}.pdf`;
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //   } catch (err) {
  //     console.error("Download failed:", err);
  //   }

  //   setMenuAnchor(null);
  // };

  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid #e5e7eb",
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "white",
        width: "auto",
        height,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1,
          bgcolor: "#f9fafb",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <Typography variant="body2" fontWeight={500}>
          {docUrl.name}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* <IconButton
            onClick={(e) => setMenuAnchor(e.currentTarget)}
            size="small"
          >
            <DownloadIcon color="primary" />
          </IconButton>

          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={() => setMenuAnchor(null)}
          >
            <MenuItem onClick={handleDownload}>Download as PDF</MenuItem>
          </Menu> */}

          {onClose && (
            <IconButton onClick={onClose} size="small">
              <CloseIcon sx={{ color: "text.secondary" }} />
            </IconButton>
          )}
        </Box>
      </Box>

      {/* PDF Viewer */}
      <Box ref={viewerRef} sx={{ flex: 1, overflow: "auto" }}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={docUrl.file}
            plugins={[defaultLayoutPluginInstance, highlightPluginInstance]}
          />
        </Worker>
      </Box>
    </Box>
  );
};

export default PdfReportEditor;
